import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import { footerMenuClick, getNonUmbracoUrl, Link } from "utils"

const StyledLayout = styled.div`
  display: none;
  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;
    justify-content: space-between;
  }
`

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const StyledLinkColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const StyledLink = styled(Link)`
  text-decoration: none;
  width: fit-content;
  &:hover {
    box-shadow: inset 0 -1px 0 0 white;
  }
  &:focus-visible {
    border: 1px dashed white;
    outline-offset: 2px;
    outline: 2px solid black;
  }
`

export default function DesktopLinks({
  megaMenuItems,
}: {
  megaMenuItems: { name: string; links: { name: string; url: string }[] }[]
}) {
  return (
    <StyledLayout>
      {megaMenuItems.map((el, i) => {
        return (
          <StyledColumn key={i}>
            <Typography
              variant="body1"
              color="white"
              style={{ fontWeight: 700 }}
              component={"h4"}
            >
              {el.name}
            </Typography>
            <StyledLinkColumn>
              {el.links.map((link, x) => (
                <StyledLink
                  href={getNonUmbracoUrl(
                    link.url.replace(/^(en|ar|he|ru)\//, "/"),
                  )}
                  key={x}
                  prefetch={false}
                  onClick={() => footerMenuClick(link.name, el.name)}
                >
                  <Typography variant="body2" color="white">
                    {link.name}
                  </Typography>
                </StyledLink>
              ))}
            </StyledLinkColumn>
          </StyledColumn>
        )
      })}
    </StyledLayout>
  )
}
